module.exports = __webpack_public_path__ + "static/media/Karolina Cison.6e2e20ce.png";